import { useFlags } from 'flagsmith/react';

export function useFeatureFlag(featureFlagName, defaultValue = false, shouldUseEnabledStatus = false) {
  const flags = useFlags([featureFlagName]);
  const flag = flags[featureFlagName];

  if (shouldUseEnabledStatus) {
    return flag.enabled;
  }

  return flag.value || defaultValue;
}
